export const LOGIN_ACTION = "LOGIN_ACTION";
export const TOGGLE_LOGOUT = "TOGGLE_LOGOUT"